import { useQuery } from "react-query";
import axios from "axios";

const getTags = async () => {
  
  const {data: tags} = await axios.get(
    `/api/v2/tags?limit=10000000&tag_type=portfolio_tag`
  );
  return tags;
};
export default function useAllTags() {
  return useQuery(["all-tags"], getTags);
}
